module.exports = __webpack_public_path__ + "img/Close_round_light.08e51c7a.svg";